import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ChevronLeft, ChevronRight, ChevronUp, Plus } from "lucide-react";
import theme from "../../../theme";
import { AnimatePresence, motion } from "framer-motion";

const SidebarContainer = styled.div`
  max-width: 550px;
  width: 100%;
  flex-shrink: 0;
  padding: 0 1rem;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 0.5rem;
  }
`;

const AccordionItem = styled.div`
  // background: ${(props) => (props.$isActive ? "white" : "white")};
  background: ${theme.colors.text.quaternary};
  border: 1px solid ${theme.colors.text.quinary};
  color: ${theme.colors.text.primary};
  border-radius: 10px;
  margin-bottom: 1rem;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
`;

const AccordionHeader = styled.div`
  padding: 10px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${(props) =>
    props.$isActive
      ? theme.colors.background.paper
      : theme.colors.text.quaternary};
  // border: 1px solid ${theme.colors.text.quinary};
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    padding: 8px 16px;
  }
`;

const AccordionTitle = styled.p`
  font-size: 1.1rem;
  margin: 0;
  font-family: "Inter", sans-serif;
  display: inline-block;
  background: ${(props) =>
    props.$hasUnderline
      ? "linear-gradient(to right, #ffffff, #ffffff)"
      : "none"};
  background-size: 100% 2px;
  background-repeat: no-repeat;
  background-position: 0 100%;
  padding-bottom: 2px;
  transition: all 0.3s ease;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const AccordionContent = styled(motion.div)`
  overflow: hidden;
  padding: 0 20px;
  background-color: ${theme.colors.themeColor};
  border-top: 1px solid #40e0d0;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

const AccordionText = styled.p`
  color: white;
  line-height: 1.6;
  margin: 0;
  font-size: 0.8rem;
  font-family: "Inter", sans-serif;
  padding: 10px 0;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    padding: 8px 0;
  }
`;

const IconWrapper = styled.div`
  transition: transform 0.3s ease;
  margin-bottom: 6px;
  transform: ${(props) =>
    props.$isCollapsed ? "rotate(0deg)" : "rotate(180deg)"};
`;

const Sidebar = ({ activeSection, onSectionChange }) => {
  const [accordionData, setAccordionData] = useState([]);

  useEffect(() => {
    fetch(`/galleryData/accordionData.json`)
      .then((response) => response.json())
      .then((data) => setAccordionData(data))
      .catch((error) => console.error("Error loading accordion data:", error));
  }, []);

  console.log(accordionData, "fgh");

  const handleClick = (item) => {
    if (item.redirect) {
      window.open(item.redirect, "_blank");
    } else {
      onSectionChange(item.id);
    }
  };

  return (
    <SidebarContainer>
      {accordionData.map((item) => (
        <AccordionItem key={item.id} $isActive={activeSection === item.id}>
          <AccordionHeader
            $isActive={activeSection === item.id}
            onClick={() => handleClick(item)}
          >
            <AccordionTitle $hasUnderline={item.id === "platform"}>
              {item.title}
            </AccordionTitle>

            <IconWrapper $isCollapsed={activeSection !== item.id}>
              {activeSection === item.id ? (
                item.isAccordian ? (
                  <ChevronUp size={20} />
                ) : (
                  <ChevronLeft size={20} />
                )
              ) : item.isAccordian ? (
                <Plus size={20} />
              ) : null}
            </IconWrapper>
          </AccordionHeader>
          <AnimatePresence initial={false}>
            {activeSection === item.id &&
              !item.redirect &&
              item.isAccordian && (
                <AccordionContent
                  key="content"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                >
                  <AccordionText>{item.content}</AccordionText>
                </AccordionContent>
              )}
          </AnimatePresence>
        </AccordionItem>
      ))}
    </SidebarContainer>
  );
};

export default Sidebar;
